module.exports = __webpack_public_path__ + "static/media/exit-icon.627d7311.svg";